import { useEffect, useRef } from 'react';
import { useLocation } from 'wouter';

// Vercel Web Analytics automatically tracks initial load with the injected script.
// For a client-side routed SPA (wouter), we manually dispatch a custom event so
// Vercel records subsequent navigations.
// Reference: https://vercel.com/docs/analytics/web/guides/framework-agnostic

// Debounce rapid route changes (e.g., redirects) to avoid noise.
const DEBOUNCE_MS = 150;

export function AnalyticsTracker() {
  const [location] = useLocation();
  const timerRef = useRef<number | null>(null);
  const lastPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (lastPathRef.current === location) return;
    lastPathRef.current = location;

    if (timerRef.current) window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => {
      try {
        window.dispatchEvent(new Event('pageview'));
        // Also send GA4 page_view (Consent Mode respects current consent)
        const url = window.location.href;
        const title = document.title || undefined;
        const path = window.location.pathname + window.location.search + window.location.hash;
        if ((window as any).gtag) {
          (window as any).gtag('event', 'page_view', {
            page_location: url,
            page_title: title,
            page_path: path,
          });
        }
      } catch (e) {
        // swallow; analytics shouldn't break the app
      }
    }, DEBOUNCE_MS);

    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, [location]);

  return null;
}

export default AnalyticsTracker;
